import SubRoute from './subRoute';

export default SubRoute;
